<template>
  <div>
    <div class="mass-action-settings">

      <el-select
        style="width: 400px"
        v-model="actionData.section_type"
        placeholder="Секция"
      >
        <el-option value="a" label="А - выше ожиданий"></el-option>
        <el-option value="b" label="В - соответствует ожиданиям"></el-option>
        <el-option value="c" label="С - частично соответствует ожиданиям"></el-option>
        <el-option value="d" label="D - не соответствует ожиданиям"></el-option>
      </el-select>

      <el-input
        style="margin-top: 20px"
        type="textarea"
        :autosize="{ minRows: 4, maxRows: 20}"
        placeholder="Текст ключевого показателя эффективности"
        v-model="actionData.message">
      </el-input>

      <el-popconfirm
        confirm-button-text='Да'
        cancel-button-text='нет'
        icon="el-icon-question"
        title="Вы уверены, что хотите заполнить ключевые показатели эффективности?"
        @confirm="doAction"
      >
        <el-button
          style="margin-top: 20px"
          slot="reference"
          size="small"
          type="primary"
        >
          Заполнить ключевые показатели эффективности
        </el-button>

      </el-popconfirm>

    </div>

    <mass-action-result
      v-if="result"
      :result="result"
    ></mass-action-result>

  </div>
</template>

<script>
import {ActionTemplateMixin} from "@/components/massActions/actionTemplates/ActionTemplateMixin";
import MassActionResult from "@/components/massActions/MassActionResult.vue";

export default {
  name: "card-abcd-admin-data-set-action",
  mixins: [ActionTemplateMixin],
  components: {MassActionResult},

  data() {
    return {
      actionData: {
        section_type: null,
        message: null,
      }
    }
  },
  methods: {},
}
</script>
